import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PATH } from './const/path';
import { LayoutDataService } from './layout-data.service';

@Component({
  selector: 'admin-layout',
  templateUrl: './layout.component.html',
})
export class LayoutComponent implements OnInit, OnDestroy {

  clazz: string;
  shown = false;
  showNavigationBar = true;
  message: { [key: string]: string } = {};
  
  private subscription$: Subscription = new Subscription();
  private notification$: Subscription = new Subscription();

  constructor(private layoutDataService: LayoutDataService) { }

  ngOnInit(): void {
    const path = sessionStorage.getItem('adminUIPath');
    if (path && path.indexOf(PATH.tasks) > -1) {
      this.showNavigationBar = false;
    } else {
      this.showNavigationBar = true;
    }
    this.subscription$ = this.layoutDataService.path$
      .subscribe(value => {
        if (value) {
          if (value.indexOf(PATH.user) > -1) {
            this.clazz = 'user-context';
          } else {
            this.clazz = null;
          }
        }
      });
  }

  ngOnDestroy() {
    this.subscription$.unsubscribe();
    this.notification$.unsubscribe();
  }

}
